import { apiPost } from "../ApiMethod";

export const loginVerify = async (data) => {
  const response = await apiPost("_loginVerify", data);
  return { ...response };
};